export default "__VITE_ASSET__wzD0fdqx__"